import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/** Hands-up 関連画面で利用する分割・会員数情報。 */
export type HandsUpInfoStateType = {
  /** 総額（税込金額） */
  total_prc_tax_include: string;
  /** 割賦総回数 */
  instlmt_total_no: string;
  /** 割賦残回数 */
  instlmt_rmnd_no: string;
  /** 割賦金額（残債） */
  instlmt_rmnd_prc: string;
  /** 前々月会員数 */
  member_count: string;
};

/**
 * Hands-up 関連情報を保持する state。
 * 活動報告書や対象判定で再利用するため、取得済みの金額・回数情報をセッションに保持する。
 */
export const HandsUpInfoState = atom<HandsUpInfoStateType>({
  key: 'HandsUpInfoState',
  default: {
    total_prc_tax_include: '',
    instlmt_total_no: '',
    instlmt_rmnd_no: '',
    instlmt_rmnd_prc: '',
    member_count: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default HandsUpInfoState;
